module.exports = __webpack_public_path__ + "static/partners-header-518c734ab5dfeb34fd68751d2d9ea395.jpg";